import React, { useState, useEffect, useContext, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";

import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";
import Editor from 'react-simple-wysiwyg';
import Select from 'react-select';
import Loader from "../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuid } from 'uuid';
import { Uploader } from "../utils/upload"
import SessionPopup from "./SessionPopup"
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import SideMenu from "./student/SideMenu";

import CreatableSelect from "react-select/creatable";
import DateTimeRangePicker2 from "../components/DateTimeRangePicker2";
import rotate_right from '../assets/images/rotate_right.svg';

let { lambda, country, appname } = window.app;
const getYouTubeVideoId = (url) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : null;
};

const customComponents = {
    DropdownIndicator: () => null, // Remove the dropdown indicator
    IndicatorSeparator: () => null, // Optionally remove the separator
};

const AddModule = () => {
    const transformRef = useRef(null);
    const viewerRef = useRef(null);

    const inputRef = useRef(null);

    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [selectedCases, setSelectedCases] = useState([]);
    const [cases, setCases] = useState([]);
    const [errors, setErrors] = useState({});


    const [youtube, setYoutube] = useState(null);
    const [baseUrl, setBaseUrl] = useState("https://qih3mm5tl8.execute-api.ap-south-1.amazonaws.com/prod/")
    const [partsize, setPartsize] = useState(100)
    const [numuploads, setNumuploads] = useState(3)
    const [ta, setTa] = useState(undefined)
    const [pgvalue, setPgvalue] = useState(undefined)
    const [perf, setPerf] = useState(undefined)


    const [youtubeError, setyoutubeError] = useState('');
    const [descriptionError, setdescriptionError] = useState('');
    const [statusError, setstatusError] = useState('');
    const [explanationError, setexplanationError] = useState('');
    const [tagError, settagError] = useState('');
    const [answer1Error, setanswer1Error] = useState('');
    const [answer2Error, setanswer2Error] = useState('');
    const [formData, setFormData] = useState('');

    const [caseIdDynamic, setCaseId] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setFeeError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [costError, setCostError] = useState('');
    const [accessCodeError, setAccessCodeError] = useState('');
    const [subModuleError, setSubModuleError] = useState('');
    const [scheduleDateError, setScheduleDateError] = useState("");
    const [scheduleStartTimeError, setScheduleStartTimeError] = useState("");
    const [scheduleEndTimeError, setScheduleEndTimeError] = useState("");
    const [scheduleEndDateError, setScheduleEndDateError] = useState("");

    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({
        "name": '',
        "description": '',
        "tags": '',
        "cost": null,
        "status": '',
        "cases": '',
        "videos": '',
    });
    const [permission, setPermission] = useState({});
    const [completedFiles, setCompletedFiles] = useState([]);

    const [success, setSuccess] = useState(false);

    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [imageCloudfront, setimageCloudfront] = useState('');

    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);

    const [imageErrorFiles, setImageErrorFiles] = useState([])
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [inputChange, setInputChange] = useState(true);
    const [questionData, setQuestionData] = useState(null);
    const [imagedisplay, setImageDisplay] = useState(false);
    const [resourceBucket, setResourceImg] = useState(false);

    const [toggleClearRows, setToggleClearRows] = useState(false);
    const [imagesUrls, setImageUrls] = useState(null);
    const [imageFiles, setImageFiles] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [alertPopup, setAlertPopup] = useState(false)
    const [alertMsg, setAlertMsg] = useState(false)
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [successAPI, setSuccessAPI] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const [uploadImg, setUploadImg] = useState(false);
    const [deleteimageType, setImageType] = useState(null);

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)

    const [uploadedFiles, setUploadedFiles] = useState([])

    const [cpcList, setCPCInfo] = useState([])

    // Deepzoom
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");

    const [dzipopupImage, setDZIPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [viewer, setViewer] = useState(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);


    const [selectedfileslist, setSelectedFiles] = useState([]);
    const [selectedVideosFiles, setSelectedVideosList] = useState([]);
    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [input, setInput] = useState("");


    const [options, setOptions] = useState([]); // dropdown list (label/value)
    const [selectedTags, setSelectedTags] = useState([]); // [{ label, value }]

    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [filteredOptionsMap, setFilteredOptionsMap] = useState({});
    const [videos, setVideos] = useState([]); // Add this for videos list
    const [selectedVideos, setSelectedVideos] = useState([]); // Add this for selected videos
    const GetCpcCasesInfo = async () => {
        try {

            const response = await tmdbApi.cpcCaseInfoForModule();
            if (response?.result) {
                // console.log(response?.result, "---")
                setCases(response?.result?.questionData || []);
            }
        } catch {
            console.log("error");
        }
    };
    // const GetCpcCasesInfo = async (tmpCases) => {
    //     try {
    //         let tableName=id?"moduleCases":null

    //         const response = await tmdbApi.cpcCaseInfoForModule(tableName,tmpCases,id);
    //         if (response?.result) {
    //             // console.log(response?.result, "---")
    //             setCases(response?.result?.questionData || []);
    //         }
    //     } catch {
    //         console.log("error");
    //     }
    // };
    const lectureLibraryInfo = async () => {
        try {
            const response = await tmdbApi.lectureLibraryInfo();
            console.log('response>>>>>>>>>>>>>>>>>>>>>>>>>', response)
            if (response?.result === "Invalid token or Expired") {
                setShowSessionPopupup(true)
                setIsLoading(false)
            }
            if (response?.result) {
                console.log(response?.result?.data, "---")
                setVideos(response?.result?.data || []);
            }
        } catch {
            console.log("error");
        }
    };

    const handleCaseChange = (selectedOptions) => {
        setSelectedCases(selectedOptions);


    };
    console.log('selectedCasesssssssssssssssssssssssss', selectedCases)
    const handleVideoChange = (selectedOptions) => {
        setSelectedVideos(selectedOptions);
    };

    useEffect(() => {
        if (!localStorage.getItem("token")) navigate("/");
        GetCpcCasesInfo();
        lectureLibraryInfo()

    }, []);

    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);


    const styles = {
        container: {
            display: "flex",
            flexWrap: "wrap",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            maxWidth: "400px"
        },
        tag: {
            display: "flex",
            alignItems: "center",
            background: "#e0e0e0",
            padding: "5px 10px",
            margin: "5px",
            borderRadius: "4px"
        },
        remove: {
            marginLeft: "8px",
            cursor: "pointer",
            color: "#888"
        },
        input: {
            flex: 1,
            border: "none",
            outline: "none",
            minWidth: "100px",
            padding: "5px",
            margin: "5px"
        }
    };

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);


    useEffect(() => {
        // console.log("imageFiles ,uploadedFiles, ", imageFiles, imageIndex, uploadedFiles)
        if (imageFiles && imageFiles?.length > 0 && uploadedFiles && uploadedFiles?.length > 0 && uploadedFiles?.length == imageFiles?.length) {
            //  updateFilesAPI()
        }
    }, [uploadedFiles]);


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            console.log('window.site.common', window.site.common)
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);


    // useEffect(() => {
    //     if (selectedCases) {
    //         let selectedFilesList = getSelectedFiles(cases, selectedCases);
    //         console.log("selectedFilesList ", selectedFilesList)
    //         setSelectedFiles(selectedFilesList)
    //     }
    // }, [selectedCases]);
    useEffect(() => {
        if (!Array.isArray(selectedCases) || selectedCases.length === 0) {
            console.log("selectedCases is not ready yet");
            return;
        }

        if (!Array.isArray(cases) || cases.length === 0) {
            console.log("cases list is not ready yet");
            return;
        }

        const selectedFilesList = getSelectedFiles(cases, selectedCases);
        console.log("selectedFilesList", selectedFilesList);
        setSelectedFiles(selectedFilesList);
    }, [selectedCases, cases]);

    useEffect(() => {
        if (!Array.isArray(selectedVideos) || selectedVideos.length === 0) {
            console.log("selectedVideos is not ready yet");
            return;
        }

        if (!Array.isArray(videos) || videos.length === 0) {
            console.log("videos list is not ready yet");
            return;
        }

        console.log("selectedVideosList", videos, selectedVideos);
        const selectedVideosList = getSelectedVideoFiles(videos, selectedVideos);
        console.log("selectedVideosList", selectedVideosList);
        setSelectedVideosList(selectedVideosList);
    }, [selectedVideos, videos]);


    // useEffect(() => {
    //     if (selectedVideos) {
    //         console.log("selectedVideosList ", videos, selectedVideos)
    //         let selectedVideosList = getSelectedVideoFiles(videos, selectedVideos);
    //         console.log("selectedVideosList ", selectedVideosList)
    //         setSelectedVideosList(selectedVideosList)
    //     }
    // }, [selectedVideos]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        getTags();
        if (id) {
            getuser();


        }
        getCpcInfo()
        GetAnswersInfo()
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);
    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            if (typeof response?.result === 'object') {
                let ans = response?.result?.answerData || [];
                if (ans.length > 0) {
                    let tmpArr = [];
                    ans.forEach(a => {
                        let obj = {
                            value: `${a.answerid}`,
                            label: a.answer
                        }
                        tmpArr.push(obj)
                    })
                    setAnswersData(tmpArr);

                    setFilteredOptionsMap({
                        answer1: tmpArr,
                        answer11: tmpArr,
                        answer2: tmpArr
                    })


                }

            }
        } catch {
            console.log("error");
        }
    };


    useEffect(() => {
        //  debugger
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity


        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };

        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });


        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);
    const rotateImage = (angle) => {
        if (viewer) {
            const newRotation = (rotation + angle) % 360;
            viewer.viewport.setRotation(newRotation);
            setRotation(newRotation);
        }
    };

    const resetZoom = () => {
        if (viewer) {
            viewer.viewport.goHome();
            viewer.viewport.setRotation(0);
            setRotation(0);
        }
    };

    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };



    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("ACTIVE,UPCOMING");
        if (response?.result === "Invalid token or Expired") {
            setIsLoading(false)
            setShowSessionPopupup(true)
            // localStorage.clear();
            // navigate("/")
        }
        else {
            if (response?.result?.length > 0) {
                setCPCInfo(response?.result)
            }
        }
    }

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    const getTags = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/tagInfo?appname=' + appname,
            // + '&userid=' + userId ,

            // + '&token=' + token,
        })
            .then(function (response) {
                console.log("response tagsssssssssssss", response?.data?.result);

                const list = response?.data?.result?.map((tag) => ({
                    label: tag.name,
                    value: tag.name,
                }));
                setOptions(list);


            });
    }
    useEffect(() => {

        setSelectedTags(tags.map((t) => ({ label: t, value: t })));

    }, [tags])

    const handleChangeTags = (newValue) => {
        setSelectedTags(newValue || []);
        const tagNames = (newValue || []).map((item) => item.value);
        setTags(tagNames); // update state as array of strings
    };

    const getuser = (e) => {
        GetTimeActivity()
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/moduleInfo?appname=' + appname + '&moduleid=' + id + '&token=' + token,
        })
            .then(function (response) {
                console.log("response", response?.data?.result);
                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setShowSessionPopupup(true)
                    // localStorage.clear();
                    // navigate("/")
                }
                else {
                    if (response?.data?.result?.data.length > 0) {
                        setEditUser(response?.data?.result?.data?.[0]);
                        // console.log(response?.data?.result, "ccssd s");
                        if (response?.data?.result?.data?.[0]?.files && response?.data?.result?.data?.[0]?.files?.length > 0) {
                            let completedFiles = response?.data?.result?.data?.[0]?.files.filter(file => file.status === "COMPLETED") || [];
                            setCompletedFiles(completedFiles)
                        }
                        console.log(cases.length, "cases")
                        let tmpCases = response?.data?.result?.data?.[0]?.cases?.map(i => i.value) || []
                        GetCpcCasesInfo(tmpCases);

                        setSelectedVideos(response?.data?.result?.data?.[0]?.videos || []);
                        setSelectedCases(response?.data?.result?.data?.[0]?.cases || []);
                        setTags(response?.data?.result?.data?.[0]?.tags || [])

                        if (response?.data?.result?.[0] && response?.data?.result?.data?.[0]?.permissions) {
                            setPermission(response?.data?.result?.data?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const handleImageErrorDelete = (e, key) => {
        setImageErrorFiles(imageErrorFiles.filter(item => item.name !== key?.name));

    }
    useEffect(() => {
        if (editUser?.type === "" || (editUser?.type !== "Timed Module" && editUser?.type !== "MCQ Module")) {
            setEditUser((prevData) => {
                const { scheduleDate, scheduleStartTime, scheduleEndTime, scheduleEndDate, accessCode, ...rest } = prevData;
                return rest;
            });
        }
    }, [editUser?.type]);



    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/')
    }

    const playVideo = (video) => {
        setShowVideoPopup(true);
        setYoutube(video);
    };

    const onDescriptionChange = (e, name) => {
        setEditUser((prevData) => ({
            ...prevData,
            [name]: e.target.value // Update the 'description' field with Quill editor value
        }));
        setInputChange(false)
    };

    const handleImageDelete = (e, key) => {
        let imgUrls = { ...imagesUrls }
        let imgIndex = imageIndex
        // console.log('imgIndex ', imgIndex)
        // console.log('imgIndex ', imgUrls[key]?.name)

        // let targetIndex = imageFiles.findIndex((each) => {each.name == imgUrls[key]?.name});
        // imageFiles.splice(targetIndex-1, 1);
        setImageFiles(imageFiles.filter(item => item.name !== imgUrls[key]?.name));

        // setImageFiles((imageFiles) => {
        //     return [
        //         ...imageFiles.filter((item, i) => item.name != imgUrls[key]?.name)
        //     ]
        // })

        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setImageUrls(imgUrls)
        setImageIndex(imgIndex - 1)

    }

    const handleImageFileDelete = async (e, item, key, type) => {
        // console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }

    const handleFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        setInputChange(false)
        let filesLength = 0
        if (editUser && editUser?.files?.length > 0) {
            filesLength = filesLength + editUser?.files.length
        }
        if (imageFiles && imageFiles?.length > 0) {
            filesLength = filesLength + imageFiles?.length
        }
        if (selectedFiles && selectedFiles?.length > 0) {
            filesLength = filesLength + selectedFiles?.length
        }


        if (filesLength > 10) {
            setAlertPopup(true)
            return;
        }
        //for multiple files
        setImageDisplay(true)
        // setImageFiles(selectedFiles)
        // setImageFiles((prevData) => ([
        //     ...prevData, // Keep the other fields intact
        //     selectedFiles
        // ]));

        Array.from(selectedFiles).map(async (file, index) => {
            console.log('file', file)
            // console.log('setImageIndex ', imageIndex, index)
            let fileSize = 1048612 * 20 // 5MB
            // if (file?.size < fileSize) {
            if (imageIndex > 0) {
                index = index + imageIndex
            }
            let urlobj = URL.createObjectURL(file)
            // let img = new Image();
            // img.onload = function () {
            // alert(this.width + " " + this.height);
            // if (this.width < 3841) {
            // if (this.width < 2000) {


            setImageFiles((prevData) => ([
                ...prevData, // Keep the other fields intact
                file
            ]));

            setImageUrls((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["blob" + index]: {
                    url: urlobj,
                    name: file?.name
                }, // Update the changed field
            }));
            setImageIndex(index + 1)
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("Resolution has been greater than 3840px and 2160px")
            //     // let obj = {
            //     //     name: file?.name,
            //     //     size: file?.size,
            //     //     width: this.width,
            //     //     height: this.height,
            //     //     error: "Resolution has been greater then 3840px and 2160px",
            //     //     url: urlobj
            //     // }
            //     // setImageErrorFiles((prevData) => ([
            //     //     ...prevData, // Keep the other fields intact
            //     //     obj
            //     // ]));
            // }
            // };
            //  img.src = urlobj;
            // } else {
            //     setFileSizeError(true)
            //     setFileSizeErrorMsg("File size greater than 20MB")
            // }


        })

    };

    const handleClinicalImageDelete = (e, key) => {
        let imgUrls = { ...clinicalimagesUrls }
        let imgIndex = clinicalimageIndex

        setclinicalImageFiles(clinicalimageFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setClinicalImageUrls(imgUrls)
        setClinicalImageIndex(imgIndex - 1)

    }

    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)
        setInputChange(false)
        // let filesLength = 0
        // if (questionData && questionData?.files?.length > 0) {
        //     filesLength = filesLength + questionData?.files.length
        // }
        // if (imageFiles && imageFiles?.length > 0) {
        //     filesLength = filesLength + imageFiles?.length
        // }
        // if (selectedFiles && selectedFiles?.length > 0) {
        //     filesLength = filesLength + selectedFiles?.length
        // }

        // //  console.log('filesLength ', filesLength)
        // if (filesLength > 10) {
        //     setAlertPopup(true)
        //     return;
        // }


        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            // let fileSize = 1048612 * 20 // 20MB
            let fileSize = 1048612 * 5 // 20MB
            if (file?.size < fileSize) {
                if (clinicalimageIndex > 0) {
                    index = index + clinicalimageIndex
                }
                console.log("index", index)
                let urlobj = URL.createObjectURL(file)
                let img = new Image();
                img.onload = function () {
                    setclinicalImageFiles((prevData) => ([
                        ...prevData, // Keep the other fields intact
                        file
                    ]));

                    setClinicalImageUrls((prevData) => ({
                        ...prevData, // Keep the other fields intact
                        ["blob" + index]: {
                            url: urlobj,
                            name: file?.name
                        }, // Update the changed field
                    }));
                    setClinicalImageIndex(index + 1)
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true)
                setFileSizeErrorMsg("File size greater than 5MB")
            }


        })

    };

    const editCaseLink = (e, file) => {

        let path = "/EditModulecase/" + file?.caseid + "/" + id
        const fullUrl = `${window.location.origin}${path}`;
        window.open(fullUrl, "_blank");
    }

    const handleKeyDown = (e) => {
        if ((e.key === "Enter" || e.key === ",") && input.trim()) {
            e.preventDefault();
            const newTag = input.trim();
            if (tags && !tags.includes(newTag)) {
                setTags([...tags, newTag]);
            }
            setInput("");
        }
        if (e.key === "Backspace" && input === "" && tags.length > 0) {
            e.preventDefault();
            const updatedTags = [...tags];
            const lastTag = updatedTags.pop();
            setTags(updatedTags);
            setInput(lastTag);
        }
    };

    const removeTag = (indexToRemove) => {
        setTags(tags.filter((_, index) => index !== indexToRemove));
    };



    const handleClickContainer = () => {
        inputRef.current.focus();
    };



    const handleFileUpload = async (clinicalimageFiles, caseid) => {
        // setUploadImg(true);

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            let filesArray = [];

            // Convert all file uploads into an array of promises
            const uploadPromises = Array.from(clinicalimageFiles).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();

                let uploadFilePath;
                let bucket;

                if (file.type.startsWith('image/')) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    //uploadFilePath = `${appname}/${caseid}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                    // const uploadFilePath = `${appname}/${caseid}/${uniqueId}/${fileNameUnique}`;
                    const uploadFilePath = `${appname}/modules/${caseid}/${uniqueId}/${fileNameUnique}`;

                    bucket = window.site && window.site.common && window.site.common.resourceBucket;

                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath
                    };

                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);

                    setFiles((files) => [...files, newFile]);

                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}&moduleid=${caseid

                            }`,
                            data,
                            { headers: { 'Content-Type': 'application/json' } }
                        );

                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            });

                            if (uploadResponse.status === 200) {
                                return true; // Successfully uploaded
                            } else {
                                throw new Error('Failed to upload file to S3');
                            }
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    } catch (error) {
                        console.error('File upload error:', error);
                        return false;
                    }
                }
            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }
    };

    const createProgressToast = (fileName) => {
        let progressToastId = toast(`Uploading ${fileName}...`, {
            progress: 0,
            closeOnClick: false,
            autoClose: false,

        });

        return progressToastId;
    };

    // Function to update progress toast
    const updateProgressToast = (toastId, progress) => {
        toast.update(toastId, {
            progress: progress / 100,
        });
    };

    // Function to close and show success or error message
    const finalizeToast = (toastId, fileName, success = true) => {
        toast.update(toastId, {
            render: success ? `${fileName} uploaded successfully!` : `${fileName} failed to upload.`,
            type: success ? 'success' : 'error',  // Using 'success' and 'error' as strings
            autoClose: 2000,
            closeOnClick: true,
        });

    };

    const handleUploadfunction = async (files, caseid) => {

        if (files && files.length > 0) {
            const uploadPromises = Array.from(files).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('clientid');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;
                // console.log("filesssss ", file)
                // Check the file type
                if (file) {
                    // File is a video
                    // uploadFilePath = `${clientid}/files/${uniqueId}_video_${timestamp}.${fileExtension}`;
                    bucket = window.site && window.site.common && window.site.common.resourceBucket; // Use source bucket for videos
                    // videoUploadFunction(uploadFilePath,bucket)
                    const timestamp = Date.now();
                    const fileExtension = file?.name?.split('.').pop();
                    const clientid = localStorage.getItem('clientid');

                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const uploadFilePath = `${appname}/${caseid}/${uniqueId}/`;
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;


                    const uploaderOptions = {
                        file: file,
                        baseURL: baseUrl,
                        chunkSize: partsize,
                        threadsQuantity: numuploads,
                        useTransferAcceleration: ta,
                        bucket: uploadFilePath,
                        fileNameUnique: fileNameUnique,
                        sourceBucket: bucket
                    };

                    let percentage = undefined;
                    setPgvalue(0);
                    setPerf("-");
                    const uploader = new Uploader(uploaderOptions);
                    const tBegin = performance.now();
                    //console.log('tBegin', tBegin);


                    const newFile = {
                        fileCreated: new Date(),
                        filename: fileNameUnique,
                        sourcepath: uploadFilePath + fileNameUnique,
                        fileid: uniqueId,
                        originalFilename: file.name,
                        uploadStatus: "INPROGRESS"
                    };
                    console.log('newwww ', newFile)
                    setUploadedFiles((uploadedFiles) => [...uploadedFiles, newFile]);

                    //const progressToastId = createProgressToast(file.name);

                    // uploader
                    //     .onProgress(({ percentage: newPercentage }) => {
                    //         // Avoid logging the same percentage twice
                    //         if (newPercentage !== percentage) {
                    //             percentage = newPercentage;
                    //             setPgvalue(percentage);
                    //             //updateProgressToast(progressToastId, percentage);

                    //             if (percentage === 100) {
                    //                 setPerf((performance.now() - tBegin) / 1000);
                    //             }
                    //         }
                    //     })
                    //     .onError((error) => {
                    //         console.error(error);
                    //        // finalizeToast(progressToastId, file.name, false);
                    //     });

                    uploader.start();


                } else {
                    // File type is neither image nor video
                    // toast.error('Unsupported file type');
                    return;
                }
                //  console.log('Upload File Path:', uploadFilePath);

            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);



            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }

    };
    const handlePopupImage = (imageUrl) => {
        console.log('imageUrl', imageUrl)
        setShowImagePopup(true)
        setPopupImage(imageUrl)
    }

    // const updateFilesAPI = () => {
    //     // console.log('uploadedFi2222 ', uploadedFiles)
    //     let payload = {
    //         files: uploadedFiles
    //     }

    //     payload["caseid"] = caseIdDynamic

    //     axios({
    //         method: 'POST',
    //         url: lambda + "/updateLearningCase?appname=" + appname + '&caseid=' + caseIdDynamic,
    //         data: payload,
    //     })
    //         .then(function (response) {


    //         });
    // }


    // const handleChange = (e) => {
    //     console.log('typeeeeeeeeee', e.target.value)
    //     console.log('nameeeee', e.target.name)
    //     if (e.target.name === "userType") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         // getPermissions(e.target.value);
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });

    //     } else if (e.target.name === "manager") {
    //         for (let key in manager) {
    //             if (manager.hasOwnProperty(key) && manager[key].userid === e.target.value) {
    //                 setEditUser({ ...editUser, [e.target.name]: e.target.value })
    //             }

    //         }

    //     } else if (e.target.name === "status") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     } else {
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     }



    // }
    const generateRandomCode = () => {
        const random = Math.random().toString(36).substring(2, 8).toUpperCase(); // 6 chars
        handleChange({ target: { name: "accessCode", value: random } });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }



        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        } else if (name === "cost") {
            const numericValue = parseFloat(value.replace(/[^0-9.]/g, ""));
            setEditUser(prev => ({ ...prev, [name]: isNaN(numericValue) ? "" : numericValue }));
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        } else if (name == "assignedCpc") {
            let assignedCpcValue = value.split("|")
            console.log("valddd ", value, assignedCpcValue[0], assignedCpcValue[1])
            setEditUser(prev => ({ ...prev, "assignedCpc": assignedCpcValue[0], "assignedCpcTitle": assignedCpcValue[1] }));
        } else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        setSuccess(false);
        navigate("/modules")
    };
    console.log('editUser', editUser)
    function onUpdateConfirm() {
        setUpdateSuccess(false);
        getuser()

        if (imageFiles && imageFiles.length > 0) {
            setImageUrls(null);
            setImageFiles([])
            setImageIndex(0)
        }

        if (clinicalimageFiles && clinicalimageFiles.length > 0) {
            setClinicalImageUrls(null);
            setclinicalImageFiles([])
            setClinicalImageIndex(0)
        }

    };
    useEffect(() => {
        const fields = [
            { key: 'submodule', setError: setSubModuleError },
            { key: 'cost', setError: setCostError },
            { key: 'name', setError: setNameError },
            { key: 'accessCode', setError: setAccessCodeError },
            { key: 'type', setError: setTypeError },
        ];

        fields.forEach(({ key, setError }) => {
            if (editUser?.[key]?.length > 0 || editUser?.[key] !== "") {
                setError("");
            }
        });
    }, [editUser]);

    const handleAddUser = (e) => {
        // console.log("kkkkkkkkkkkkkkkkkkkkkkkkkkk")
        GetTimeActivity()
        const cleanDescription = editUser?.description?.replace(/<br\s*\/?>/gi, "").trim();
        if (
            editUser?.status === "ACTIVE" &&
            (
                !editUser?.type ||
                editUser?.type === "" ||
                !cleanDescription ||
                (
                    editUser?.type !== "CPC Module" &&
                    editUser?.type !== "MCQ Module" &&
                    (!selectedCases || selectedCases.length <= 0)
                )
            )
        ) {
            setAlertMsg(true);
            return; // Stop function execution
        }

        const isValid = formvalidation();
        if (isValid) {
            const caseid = uuid();
            // if (imageFiles && imageFiles.length > 0) {
            //   handleFileUpload(caseid, "create")
            // } else {
            createuser(imageFiles, caseid);
            //  }

        } else {
            toast.error("Please fill all required fields", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    console.log('kirannnnnnnn')

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;

        if (editUser?.type === undefined || editUser?.type === null || editUser?.type === "") {
            setTypeError("Please select Module Type");
            formIsValid = false;
        } else {
            setTypeError("")
        }

        if (editUser?.name === undefined || editUser?.name?.trim() === "") {
            setNameError("Please enter Name");
            formIsValid = false;
        } else {
            setNameError("")
        }

        if (editUser.type !== "Timed Module" && editUser.type !== "MCQ Module") {
            if (editUser?.cost === undefined || editUser?.cost === null || editUser?.cost === "") {
                setCostError("Please enter Cost");
                formIsValid = false;
            } else {
                setCostError("")
            }
        }
        if (editUser.type === "Learning Module") {
            if (editUser?.submodule === undefined || editUser?.submodule === null || editUser?.submodule === "") {
                setSubModuleError("Please Select Sub Module");
                formIsValid = false;
            } else {
                setSubModuleError("")
            }
        }
        if (editUser.type === "Timed Module") {


            if (editUser?.accessCode === undefined || editUser?.accessCode === null || editUser?.accessCode === "") {
                setAccessCodeError("Please Enter Access Code");
                formIsValid = false;
            } else {
                setAccessCodeError("")
            }
            // Access Code Validation
            if (
                editUser?.accessCode === undefined ||
                editUser?.accessCode === null ||
                editUser?.accessCode === ""
            ) {
                setAccessCodeError("Please Enter Access Code");
                formIsValid = false;
            } else {
                setAccessCodeError("");
            }

            // Schedule Date Validation
            if (
                editUser?.scheduleDate === undefined ||
                editUser?.scheduleDate === null ||
                editUser?.scheduleDate === ""
            ) {
                setScheduleDateError("Please Enter Schedule Date");
                formIsValid = false;
            } else {
                setScheduleDateError("");
            }

            // Schedule Start Time Validation
            if (
                editUser?.scheduleStartTime === undefined ||
                editUser?.scheduleStartTime === null ||
                editUser?.scheduleStartTime === ""
            ) {
                setScheduleStartTimeError("Please Enter Schedule Start Time");
                formIsValid = false;
            } else {
                setScheduleStartTimeError("");
            }

            // Schedule End Time Validation
            if (
                editUser?.scheduleEndTime === undefined ||
                editUser?.scheduleEndTime === null ||
                editUser?.scheduleEndTime === ""
            ) {
                setScheduleEndTimeError("Please Enter Schedule End Time");
                formIsValid = false;
            } else {
                setScheduleEndTimeError("");
            }

            // Schedule End Date Validation
            if (
                editUser?.scheduleEndDate === undefined ||
                editUser?.scheduleEndDate === null ||
                editUser?.scheduleEndDate === ""
            ) {
                setScheduleEndDateError("Please Enter Schedule End Date");
                formIsValid = false;
            } else {
                setScheduleEndDateError("");
            }

        }

        if (editUser.type === "MCQ Module") {
            // Schedule Date Validation
            if (
                editUser?.scheduleDate === undefined ||
                editUser?.scheduleDate === null ||
                editUser?.scheduleDate === ""
            ) {
                setScheduleDateError("Please Enter Schedule Date");
                formIsValid = false;
            } else {
                setScheduleDateError("");
            }

            // Schedule Start Time Validation
            if (
                editUser?.scheduleStartTime === undefined ||
                editUser?.scheduleStartTime === null ||
                editUser?.scheduleStartTime === ""
            ) {
                setScheduleStartTimeError("Please Enter Schedule Start Time");
                formIsValid = false;
            } else {
                setScheduleStartTimeError("");
            }

            // Schedule End Time Validation
            if (
                editUser?.scheduleEndTime === undefined ||
                editUser?.scheduleEndTime === null ||
                editUser?.scheduleEndTime === ""
            ) {
                setScheduleEndTimeError("Please Enter Schedule End Time");
                formIsValid = false;
            } else {
                setScheduleEndTimeError("");
            }

            // Schedule End Date Validation
            if (
                editUser?.scheduleEndDate === undefined ||
                editUser?.scheduleEndDate === null ||
                editUser?.scheduleEndDate === ""
            ) {
                setScheduleEndDateError("Please Enter Schedule End Date");
                formIsValid = false;
            } else {
                setScheduleEndDateError("");
            }
        }

        // if (id && tags && tags?.length == 0) {
        //     settagError("Please enter Tags");
        //     // setTimeout(() => settagError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     settagError("")
        // }

        // if (id && (editUser?.description === undefined || editUser?.description?.trim() === "")) {
        //     setdescriptionError("Please enter Clinical history");
        //     // setTimeout(function () { setdescriptionError("") }, 3000);
        //     formIsValid = false;
        // } else {
        //     setdescriptionError("")
        // }



        // if (id && !editUser?.explanation?.trim()) {
        //     setexplanationError("Please enter Explanation");
        //     //  setTimeout(() => setexplanationError(""), 3000);
        //     formIsValid = false;
        // } else {
        //     setexplanationError("")
        // }

        // if (id && !editUser?.answer1?.value) {
        //     setanswer1Error("Please select answer (1 Point)");
        //     //setTimeout(() => setanswer1Error(""), 3000);
        //     formIsValid = false;
        // } else {
        //     setanswer1Error("")
        // }


        // if (id && !editUser?.answer2?.value) {
        //     setanswer2Error("Please select answer (0.5 point)");
        //     setTimeout(() => setanswer2Error(""), 3000);
        //     formIsValid = false;
        // }

        // if (editUser?.status === undefined || editUser?.status?.trim() === "") {
        //     setstatusError("Please enter status");
        //     setTimeout(function () { setstatusError("") }, 3000);
        //     formIsValid = false;
        // }

        // if (editUser?.type === "ACCOUNTMANAGER" || editUser?.type === "CONTENTMANAGER" || editUser?.type === "MANAGER") {
        //     if (editUser?.manager === "" || editUser?.manager === undefined) {
        //         setManagerTypeError("Please select Manager");
        //         setTimeout(function () { setManagerTypeError("") }, 3000);
        //         formIsValid = false;
        //     }
        // }

        return formIsValid;
    }


    const handleSubmit = (status) => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "name": editUser?.name,
            "description": editUser?.description,
            "tags": tags,
            "cost": editUser?.cost,
            "status": editUser?.status,
            "cases": selectedCases,
            "videos": selectedVideos,
            "type": editUser?.type
        }


        payload["moduleid"] = id


        axios({
            method: 'POST',
            url: lambda + "/updateModule?appname=" + appname + '&moduleid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (imageFiles && imageFiles?.length > 0) {
                        handleUploadfunction(imageFiles, id)
                    }
                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, id)
                    }
                    setCaseId(id)
                    if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        //setSuccessAPI(true)
                        setSuccessMsg("Updated Successfully")
                        //setToastMessage("Updated Successfully")

                        //if (id && imageFiles?.length == 0) {
                        // getuser();


                        //}
                        setTimeout(() => {
                            // navigate("/modules"); // Trigger API call AFTER toast is displayed
                        }, 2000);
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        const isValid = formvalidation();
        // if (imageFiles && imageFiles.length > 0) {
        //   handleFileUpload(id, "update")
        //  } else {
        const cleanDescription = editUser?.description?.replace(/<br\s*\/?>/gi, "").trim();
        if (
            editUser?.status === "ACTIVE" &&
            (
                !editUser?.type ||
                editUser?.type === "" ||
                !cleanDescription ||
                (
                    editUser?.type !== "CPC Module" &&
                    editUser?.type !== "MCQ Module" &&
                    (!selectedCases || selectedCases.length <= 0)
                )
            )
        ) {
            setAlertMsg(true)
            return; // Stop function execution
        }
        if (isValid) {
            handleSubmit();
        }

    }

    const createuser = async (imageFiles, caseid) => {
        setIsLoading(true)


        // GetTimeActivity()   
        let payload = {}
        payload = {
            "name": editUser?.name,
            "description": editUser?.description,
            "tags": tags,
            "cost": editUser?.cost,
            "status": editUser?.status,
            "cases": selectedCases,
            "videos": selectedVideos,
            "type": editUser?.type,

        }
        const conditionalKeys = [
            "scheduleDate",
            "scheduleStartTime",
            "scheduleEndTime",
            "scheduleEndDate",
            "accessCode",
        ];

        // Dynamically add them if they have a truthy value
        conditionalKeys.forEach((key) => {
            if (editUser?.[key]) payload[key] = editUser[key];
        });
        payload["moduleid"] = caseid
        if (editUser?.type === "Learning Module") {
            payload["submodule"] = editUser?.submodule
        }
        if(editUser?.type ==="MCQ Module"){
           payload["googleFormUrl"] = editUser?.googleFormUrl
        }
        //payload["status"] = status


        const userId = localStorage.getItem("userId")

        axios({
            method: 'POST',
            url: lambda + "/addLearningModule?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.resultimageFiles", response, imageFiles, caseid)
                    // if (imageFiles && imageFiles?.length > 0) {
                    //     handleUploadfunction(imageFiles, caseid)
                    // }

                    if (clinicalimageFiles && clinicalimageFiles?.length > 0) {
                        handleFileUpload(clinicalimageFiles, caseid)
                    }

                    setCaseId(caseid)

                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                        // localStorage.clear();
                        // navigate("/")
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);

                        setSuccessMsg("Created Successfully")

                        // setToastMessage("Created Successfully")
                        //setTimeout(() => {
                        // navigate("/modules"); // Trigger API call AFTER toast is displayed
                        //}, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/modules",
                state: { search: true }
            });
        } else {
            navigate("/modules")
        }
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/modules")
    }

    const getSelectedVideoFiles = (videos, selectedvideos) => {
        const selectedIds = selectedvideos.map((c) => c.value);

        // Filter matching cases and extract their files
        return videos
            .filter((c) => selectedIds.includes(c._id))
            .flatMap((c) => c); // merge all matched files into a single array
    };

    const getSelectedFiles = (cases, selectedcases) => {
        const selectedIds = selectedcases.map((c) => c.value);

        // Filter matching cases and extract their files
        return cases
            .filter((c) => selectedIds.includes(c.caseid))
            .flatMap((c) => c); // merge all matched files into a single array
    };

    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;
        // console.log('menuItemIndex',menuItemIndex)
        // console.log('submenuIndex',submenuIndex)
        setPermission(prevState => {
            if (submenuIndex === undefined) {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
        });
        // console.log('permissionss',permission)
    };

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;
        // console.log('typeeee',type)
        // console.log('index',index)
        // console.log('subIndex',subIndex)
        // console.log('updatedPermission',updatedPermission)
        // console.log('typeOfItem',typeOfItem)
        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
    };


    const handlePopupload = (e) => {
        setPopupLoading(true)
    }

    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
                "fileid": deleteImageId?.fileid
            }


            await tmdbApi.deleteModuleFiles(id, params);



            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        // let deleteImageIndex = deleteImageId["index"]
        // if (deleteImageIndex > -1) { // only splice array when item is found
        //     editUser["historyfiles"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        // }
        setDeleteImageId(null)
        // let imgIndex = clinicalimageIndex
        // setClinicalImageIndex(imgIndex - 1)
        getuser()
    }

    // console.log("imageFiles", imagesUrls, imageFiles);



    const handleSelectChange = (selectedOption, aIndex) => {
        setEditUser((prevData) => ({
            ...prevData,
            [aIndex]: selectedOption // Update the 'description' field with Quill editor value
        }));
    }

    console.log("editUser?.type", editUser?.type)

    const handleInputChange = (inputValue, aIndex) => {

        if (inputValue !== "") {
            const results = answers?.filter(option =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
            );
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: results
            }));
        } else {
            setFilteredOptionsMap(prev => ({
                ...prev,
                [`${aIndex}`]: answers
            }));
        }
    };


    console.log("clinicalimageFilessssssssssssssssssssssssss", showSessionPopupup);
    return (
        <>
            {
                showSessionPopupup &&

                <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                {/* <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert> */}
                {!invalidContent &&

                    <div className="main-content user-management create-user edit-module-page add-module-resp" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "MODULE DETAILS" : "EDIT MODULE"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Learning Hub</span> / <b id="breadcrumb-action">{id === undefined ? "ADD MODULE" : "EDIT MODULE"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {Object.keys(editUser)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">
                                                    <div className="d-flex flex-wrap col-lg-12 col-md-12 justify-content-between align-items-start">
                                                        <div className="col-lg-6 col-md-12">

                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label" htmlFor="module-select">
                                                                        MODULE TYPE<span className="required">*</span>
                                                                    </label>
                                                                    <select
                                                                        id="module-select"
                                                                        className="colorselect capitalize form-control form-select"
                                                                        name="type"
                                                                        onChange={handleChange}
                                                                        value={editUser?.type}
                                                                    >
                                                                        <option value="" id="module-option-default">Select Module</option>
                                                                        <option value="Learning Module" id="learning-module">Learning Module</option>
                                                                        <option value="CPC Module" id="cpc-module">CPC Module</option>
                                                                        <option value="Timed Module" id="timed-module">Timed Module</option>
                                                                        <option value="MCQ Module" id="mcq-module">MCQ Module</option>
                                                                    </select>
                                                                    <span id="type-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{typeError}</span>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Name<span className="required">*</span></label>
                                                                    <input id="name" name="name" placeholder="Enter Name" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.name} />
                                                                    <span id="name-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span>
                                                                </div>
                                                            </div>


                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field clinical-history">
                                                                    <label className="form-label form-label">Description
                                                                        {/* {id && <span className="required">*</span>} */}
                                                                    </label>

                                                                    <Editor name="description" value={editUser?.description} onChange={(e) => onDescriptionChange(e, 'description')} />

                                                                    <span id="status-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{descriptionError}</span>



                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12 col-md-12 editmodule-tags">
                                                                <div className="mb-3 input-field">

                                                                    <label className="form_label">Tags
                                                                        {/* {id && <span className="required">*</span>} */}
                                                                    </label>

                                                                    <div className="mb-3 input-field">
                                                                        {/* 
                                                                        <div
                                                                            onClick={handleClickContainer}
                                                                            style={{
                                                                                display: "flex",
                                                                                flexWrap: "wrap",
                                                                                border: "1px solid #ccc",
                                                                                borderRadius: "4px",
                                                                                padding: "5px",
                                                                                cursor: "text",
                                                                                minHeight: "40px",
                                                                                alignItems: "center",

                                                                            }}
                                                                        >
                                                                            {tags.map((tag, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        background: "#e0e0e0",
                                                                                        borderRadius: "4px",
                                                                                        padding: "2px 6px",
                                                                                        margin: "2px",
                                                                                    }}
                                                                                >
                                                                                    {tag}
                                                                                    <span
                                                                                        onClick={() => removeTag(index)}
                                                                                        style={{ marginLeft: "5px", cursor: "pointer", color: "#888" }}
                                                                                    >
                                                                                        ×
                                                                                    </span>
                                                                                </div>
                                                                            ))}
                                                                            <input
                                                                                ref={inputRef}
                                                                                value={input}
                                                                                onChange={(e) => setInput(e.target.value)}
                                                                                onKeyDown={handleKeyDown}
                                                                                style={{
                                                                                    flex: 1,
                                                                                    border: "none",
                                                                                    outline: "none",
                                                                                    minWidth: "80px",
                                                                                }}
                                                                                placeholder="Type and press Enter"

                                                                            />

                                                                        </div> */}

                                                                        <div
                                                                            style={{ width: "100%", maxWidth: "600px" }}


                                                                        >

                                                                            <CreatableSelect
                                                                                isMulti
                                                                                options={options}
                                                                                value={selectedTags}
                                                                                onChange={handleChangeTags}
                                                                                placeholder="Type and press Enter"
                                                                                styles={{
                                                                                    multiValue: (base) => ({
                                                                                        ...base,
                                                                                        backgroundColor: "#e0e0e0",
                                                                                        borderRadius: "6px",
                                                                                        padding: "2px 6px",
                                                                                    }),
                                                                                }}
                                                                            />

                                                                        </div>

                                                                        {/* <textarea
                                                                        className="form-control"
                                                                        id="productdesc"
                                                                        value={input}
                                                                        onChange={(e) => setInput(e.target.value)}
                                                                        onKeyDown={handleKeyDown}
                                                                        rows={5}
                                                                        cols={3}
                                                                        placeholder="Type and press enter">
                                                                    </textarea>
                                                                    <div className="d-flex">

                                                                        {tags?.map((tag, index) => (
                                                                            <div key={index} style={styles.tag}>
                                                                                {tag}
                                                                                <span style={styles.remove} onClick={() => removeTag(index)}>×</span>

                                                                            </div>
                                                                        ))}
                                                                    </div> */}




                                                                        <span id="tag-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{tagError}</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="row col-md-12 col-sm-12">
                                                                <div className="col-lg-6 edit-module-select-fields">

                                                                    {editUser?.type === "Learning Module" &&
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label" htmlFor="module-select">
                                                                                    SUB MODULE TYPE<span className="required">*</span>
                                                                                </label>
                                                                                <select
                                                                                    id="module-select"
                                                                                    className="colorselect capitalize form-control form-select"
                                                                                    name="submodule"
                                                                                    onChange={handleChange}
                                                                                    value={editUser?.submodule}

                                                                                >
                                                                                    <option value="" id="module-option-default">Select Sub Module</option>

                                                                                    <option value="SELF" id="self-assessment">Self Assessment</option>
                                                                                    <option value="FELLOWSHIP" id="fellowship">Fellowship</option>

                                                                                </select>
                                                                                <span id="tag-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{subModuleError}</span>

                                                                            </div>
                                                                        </div>}

                                                                    {editUser?.type === "MCQ Module" &&
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">Google Form Embed URL<span className="required">*</span></label>
                                                                                <input
                                                                                    id="googleFormUrl"
                                                                                    name="googleFormUrl"
                                                                                    placeholder="Enter Google Form Embed URL"
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    aria-invalid="false"
                                                                                    onChange={(e) => handleChange(e)}
                                                                                    value={editUser?.googleFormUrl || ""}
                                                                                />
                                                                            </div>
                                                                        </div>}

                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">Cost  {editUser.type !== "Timed Module" && editUser.type !== "MCQ Module" && <span className="required">*</span>}</label>
                                                                            <input id="cost" name="cost" placeholder="Enter Cost" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.cost} />
                                                                            <span id="cost-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{costError}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12 col-md-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label" htmlFor="usertype-select">
                                                                                STATUS
                                                                            </label>
                                                                            <select
                                                                                id="usertype-select"
                                                                                className="colorselect capitalize form-control form-select"
                                                                                name="status"
                                                                                onChange={handleChange}
                                                                                value={editUser?.status}

                                                                            >
                                                                                <option value="" id="usertype-option-default">Select Type</option>
                                                                                <option value="ACTIVE" id="usertype-option-superadmin">ACTIVE</option>
                                                                                <option value="INACTIVE" id="usertype-option-superadmin">INACTIVE</option>
                                                                            </select>

                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-6"></div>




                                                                </div>
                                                                <div className="col-lg-6 col-mb-12 mt-2 edit-module-upload-image">

                                                                    <div className="col-md-12 upload-imgs-edit-mod">
                                                                        <div className="d-flex col-lg-12 align-items-start justify-content-between upload-img-section">
                                                                            <label className="form_label col-12">Upload Image</label>
                                                                        </div>

                                                                        <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-1">



                                                                            {/* Uploaded clinical images */}
                                                                            {/* THUMBNAIL GRID */}
                                                                            <div className="uploaded_images-grid mt-0" /* grid container */>
                                                                                {/* ── Clinical images from local upload ─────────────────── */}
                                                                                {(clinicalimagesUrls && Object.keys(clinicalimagesUrls).length > 0) ||
                                                                                    (Array.isArray(editUser?.modulefiles) && editUser.modulefiles.length > 0) ? (
                                                                                    <>
                                                                                        {clinicalimagesUrls && Object.keys(clinicalimagesUrls).length > 0 &&
                                                                                            Object.keys(clinicalimagesUrls).map((item, key) => (
                                                                                                <div className="thumb-box" key={key}>
                                                                                                    <div
                                                                                                        className="thumb-img cursor-pointer"
                                                                                                         style={{ cursor: "pointer" }}
                                                                                                        // onClick={() => handlePopupImage(clinicalimagesUrls[item].url)}
                                                                                                        onClick={() =>
                                                                                                            handlePopupImage(
                                                                                                                clinicalimagesUrls[item].file
                                                                                                                    ? URL.createObjectURL(clinicalimagesUrls[item].file)
                                                                                                                    : clinicalimagesUrls[item].url
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        <img

                                                                                                            // src={clinicalimagesUrls[item].url} 
                                                                                                            src={
                                                                                                                clinicalimagesUrls[item].file
                                                                                                                    ? URL.createObjectURL(clinicalimagesUrls[item].file)
                                                                                                                    : clinicalimagesUrls[item].url
                                                                                                            }
                                                                                                            alt="uploaded" />                                                                                                        <span
                                                                                                                className="icon-close"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleClinicalImageDelete(e, item, key, "file");
                                                                                                                }}
                                                                                                            >
                                                                                                            ×
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))
                                                                                        }

                                                                                        {Array.isArray(editUser?.modulefiles) && editUser.modulefiles.length > 0 &&
                                                                                            editUser.modulefiles.map((item, key) => {
                                                                                                const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`;
                                                                                                return (
                                                                                                    <div className="thumb-box" key={key}>
                                                                                                        <div
                                                                                                            style={{ cursor: "pointer" }}
                                                                                                            className="thumb-img cursor-pointer"
                                                                                                            // onClick={() => handlePopupImage(imagePath)}
                                                                                                            onClick={() =>
                                                                                                                handlePopupImage(
                                                                                                                    item?.file
                                                                                                                        ? URL.createObjectURL(item.file)
                                                                                                                        : imagePath
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <img src={`${imagePath}`} alt="history" />
                                                                                                            <span
                                                                                                                className="icon-close"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleImageFileDelete(e, item, key, 'file');
                                                                                                                }}
                                                                                                            >
                                                                                                                ×
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="upload-box">
                                                                                        <div className="file_upload add-box">
                                                                                            <input
                                                                                                type="file"
                                                                                                id="file-upload"
                                                                                                accept="image/jpeg, image/png"
                                                                                                className="file-input"
                                                                                                onChange={handleimageFileChange}
                                                                                                style={{ display: "none" }}
                                                                                            />
                                                                                            <label htmlFor="file-upload" className="Add-btn d-flex align-items-center justify-content-center flex-column">
                                                                                                <p className="mb-0">
                                                                                                    <span className="material-symbols-outlined plus-icon">add</span>
                                                                                                </p>
                                                                                                ADD
                                                                                            </label>
                                                                                        </div>
                                                                                        <p className="mt-0 mb-0 text-start col-12 file-format upload-img-note">
                                                                                            Note: File size: 5 MB | Supported Formats: JPG, PNG
                                                                                        </p>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                        </div>
                                                                    </div>


                                                                    <div className="row col-lg-12 mt-4 ">


                                                                        <div className="d-flex justify-content-start col-lg-12 histology-photo-section gap-2 mt-3">

                                                                            <div className="mb-3 mt-2 input-field deep-zoom-styles">

                                                                                {imagesUrls &&
                                                                                    Object.keys(imagesUrls).length > 0 &&
                                                                                    Object.keys(imagesUrls).map((item, key) => (
                                                                                        <div className="upload_images d-flex gap-2 align-items-start" key={key}>
                                                                                            <div className="img">
                                                                                                <p className="text-truncate small mb-0">{imagesUrls[item].name}</p>
                                                                                                <span className="default-img"><img src={deepZoom} alt="" /></span>

                                                                                            </div>

                                                                                            <span
                                                                                                onClick={(e) => handleImageDelete(e, item)}
                                                                                                className="icon-close"
                                                                                            >
                                                                                                x
                                                                                            </span>
                                                                                        </div>
                                                                                    ))}



                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div classname="access-code-reponsive">
                                                                    {editUser.type === "Timed Module" &&
                                                                        <div className="schedule-form access-code-reponsive">
                                                                            <DateTimeRangePicker2 formData={editUser} setFormData={setEditUser} IsDisabled={false} isModifyClassName={true} />
                                                                        </div>
                                                                    }
                                                                    {editUser.type === "MCQ Module" &&
                                                                        <div className="schedule-form access-code-reponsive">
                                                                            <DateTimeRangePicker2 formData={editUser} setFormData={setEditUser} IsDisabled={false} isModifyClassName={true} />
                                                                        </div>
                                                                    }
                                                                </div>
                                                                {/* <div className="col-lg-12 access-code-reponsive">
                                                                        {editUser.type === "Timed Module" &&
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">Access Code<span className="required">*</span></label>
                                                                                <input id="AccessCode" name="accessCode" placeholder="Enter Access Code" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.accessCode} />
                                                                                <span id="cost-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{accessCodeError}</span>
                                                                            </div>
                                                                        </div>}
                                                                   
                                                                </div> */}
                                                                <div className="col-lg-12 ">
                                                                    {editUser.type === "Timed Module" &&
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field" style={{ position: "relative" }}>
                                                                                <label className="form_label">
                                                                                    Access Code <span className="required">*</span>
                                                                                </label>

                                                                                <input
                                                                                    id="AccessCode"
                                                                                    name="accessCode"
                                                                                    placeholder="Enter Access Code"
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    aria-invalid="false"
                                                                                    onChange={(e) => handleChange(e)}
                                                                                    value={editUser?.accessCode}
                                                                                    style={{ paddingRight: "90px" }}  // space for button
                                                                                />

                                                                                {/* Generate Button Inside Input */}
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={generateRandomCode}
                                                                                    // className="fill-btn-style create-quiz-btn border-0"
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        right: "5px",
                                                                                        top: "30px",
                                                                                        padding: "5px 11px",
                                                                                        background: "#EA7F4A",
                                                                                        color: "#fff",
                                                                                        border: "none",
                                                                                        borderRadius: "4px",
                                                                                        cursor: "pointer",
                                                                                        fontSize: "14px",
                                                                                    }}
                                                                                >
                                                                                    Generate
                                                                                </button>

                                                                                <span
                                                                                    id="cost-error"
                                                                                    className="errormsg"
                                                                                    style={{ fontWeight: "bold", color: "red" }}
                                                                                >
                                                                                    {accessCodeError}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>

                                                            </div>




                                                        </div>


                                                        <div className="row col-lg-5 col-md-12 video-edit-section access-code-reponsive">
                                                            {/* {editUser?.files && editUser?.files.length > 0 && */}
                                                            {editUser?.type !== "MCQ Module" && <>
                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="input-field">
                                                                    <label className="form_label">Cases </label>
                                                                    {cases && (
                                                                        <Select
                                                                            isMulti
                                                                            value={selectedCases}
                                                                            options={
                                                                                Array.isArray(cases)
                                                                                    ? cases
                                                                                        .filter((item) => item.diagnosis)
                                                                                        .map((eachItem) => ({
                                                                                            value: `${eachItem.caseid}`,
                                                                                            label: eachItem.diagnosis,
                                                                                        }))
                                                                                    : []
                                                                            }
                                                                            name="cases"
                                                                            onChange={handleCaseChange}
                                                                            placeholder="Select"
                                                                            classNamePrefix="my-select"


                                                                        />
                                                                    )}
                                                                    {errors?.cases && <div className="text-danger">{errors.cases}</div>}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 edit-module-cases">
                                                                <div className="d-flex justify-content-start flex-wrap col-lg-12 histology-photo-section gap-3 mt-2">
                                                                    {selectedCases?.length > 0 && selectedfileslist.map((file, key) => {
                                                                        // console.log("fileeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",file)
                                                                        return (
                                                                            <div className="d-flex gap-4 flex-wrap" key={key} >
                                                                                <div
                                                                                    className="img cursor-pointer"

                                                                                >
                                                                                    <div className={`cases-imgs ${!file?.files?.[0]?.thumbnailUrl ? 'cases-default-static-img' : ''}`}

                                                                                    //  onClick={(e) => editCaseLink(e, file)}

                                                                                    // style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        {/* <span className="material-symbols-outlined img_view deep-zzom-ope-icon">zoom_out_map</span> */}
                                                                                        <span className={`default-img ${!file?.files?.[0]?.thumbnailUrl ? 'default-static-img' : ''}`}><img src={file?.files?.[0]?.thumbnailUrl ? `${imageCloudfront}${file?.files?.[0]?.thumbnailUrl.replace(/^\/+/, '').replace(/ /g, '%20')}` : deepZoom} alt="" /></span>
                                                                                    </div>

                                                                                    <span className="default-img-title">{file?.diagnosis}</span>


                                                                                </div>

                                                                            </div>
                                                                        )
                                                                    }


                                                                    )}
                                                                </div>

                                                            </div>
                                                            </>}



                                                            <div className="col-lg-12 col-md-12 mt-3">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label">Videos </label>
                                                                    {Array.isArray(videos) && (
                                                                        <Select
                                                                            isMulti
                                                                            value={selectedVideos || []}
                                                                            options={
                                                                                Array.isArray(videos)
                                                                                    ? videos
                                                                                        .filter((item) => item.youtube != "")
                                                                                        .map((eachItem) => ({
                                                                                            value: `${eachItem._id}`,
                                                                                            label: eachItem.title,
                                                                                        }))
                                                                                    : []
                                                                            }
                                                                            name="videos"
                                                                            onChange={handleVideoChange}
                                                                            placeholder="Select"
                                                                            classNamePrefix="my-select"

                                                                        />


                                                                    )}
                                                                    {errors?.videos && <div className="text-danger">{errors.videos}</div>}




                                                                </div>
                                                            </div>



                                                            <div className="col-lg-12 col-md-12 row video-edit-module-section">

                                                                {selectedVideosFiles.map((file, key) => (


                                                                    <div className="col-lg-4" style={{ marginTop: "10px" }}>
                                                                        <img
                                                                            src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                                                                                file?.youtube
                                                                            )}/0.jpg`}
                                                                            alt="YouTube Thumbnail"
                                                                            style={{
                                                                                width: "100%",
                                                                                maxWidth: "300px",
                                                                                cursor: "pointer",
                                                                            }}

                                                                            onClick={() => playVideo(file.youtube)}
                                                                        />
                                                                        <p className="d-flex justify-content-start align-items-center gap-2"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => playVideo(file.youtube)}
                                                                        >
                                                                            {/* <span className="material-symbols-outlined">
                                                                                    smart_display
                                                                                </span>  */}
                                                                            <span className="pre-vid-txt">{file.title}</span>
                                                                        </p>
                                                                    </div>
                                                                ))}




                                                                {showVideoPopup && (
                                                                    <div
                                                                        style={{
                                                                            position: "fixed",
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            backgroundColor: "rgba(0,0,0,0.8)",
                                                                            zIndex: 1000,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                        onClick={() => setShowVideoPopup(false)}
                                                                    >
                                                                        <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                                                                            <iframe
                                                                                width="100%"
                                                                                height="450"
                                                                                src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                                                                    youtube
                                                                                )}`}
                                                                                frameBorder="0"
                                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                allowFullScreen
                                                                                title="Video Preview"
                                                                            ></iframe>
                                                                            <button className="create-quiz-btn"
                                                                                onClick={() => setShowVideoPopup(false)}
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    top: 10,
                                                                                    right: 10,
                                                                                    border: "none",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                            >
                                                                                Close
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>


                                                            <style>
                                                                {
                                                                    `
                                                                textarea.form-control {
                                                                min-height: calc(6.5em + .75rem + 2px) !important;}
                                                                `
                                                                }
                                                            </style>
                                                            {/*  */}






                                                        </div>



                                                    </div>




                                                </div>
                                                <div className="line">

                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 d-flex" >



                                                    {id && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleUpdate(e)} >{isLoading && (
                                                        <img
                                                            src={rotate_right}
                                                            className="loading-icon"
                                                            id="loginPwdLoading"
                                                            alt="loading"
                                                        />
                                                    )}Update
                                                    </button>}


                                                    {id === undefined && <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="button" onClick={e => handleAddUser(e)}>{isLoading && (
                                                        <img
                                                            src={rotate_right}
                                                            className="loading-icon"
                                                            id="loginPwdLoading"
                                                            alt="loading"
                                                        />
                                                    )}Save
                                                    </button>}

                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <Footer id="footer" />
                    </div>

                }


                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1003,
                            display: "flex",
                            alignItems: "start",
                            justifyContent: "center",
                            padding: "20px", // padding all around
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        <div
                            style={{
                                position: "relative",
                                width: "auto",
                                height: "100%",
                                padding: "20px", // inner padding so image doesn't touch edges
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "start",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={popupImage}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />

                            <button
                                className="dz_close"
                                onClick={() => setShowImagePopup(false)}
                                style={{
                                    position: "absolute",
                                    top: 30,
                                    right: 30,
                                    cursor: "pointer",
                                    borderRadius: "6px",
                                }}
                            >
                                <span className="material-symbols-outlined">close</span>
                            </button>
                        </div>
                    </div>


                )}
            </div>



            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                close
                            </span>
                        </button>

                        {/* Zoomable Image */}

                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button>
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={dzipopupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ""} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button> */}
                                    {/* <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>
                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                position: "absolute",
                                bottom: "20px",
                                left: "20px",
                                backgroundColor: "rgba(0, 0, 0, 0.7)",
                                color: "white",
                                padding: "10px",
                                borderRadius: "5px",
                                fontSize: "12px"
                            }}>
                                <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {dziUrl && (
                <section className="viewer-section">
                    <div className="viewer-header">
                        <h2>Deep Zoom Viewer</h2>
                        <div className="viewer-controls">
                            <button className="control-button" onClick={() => window.location.reload()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 2v6h-6"></path>
                                    <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                                    <path d="M3 22v-6h6"></path>
                                    <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                                </svg>
                                <span>Reset</span>
                            </button>
                        </div>
                    </div>

                    <div className="viewer-container">
                        <div id="openseadragon-viewer" ref={viewerRef}></div>
                        <div className="viewer-instructions">
                            <p>• Zoom with mouse wheel or pinch gesture</p>
                            <p>• Pan by clicking and dragging</p>
                            <p>• Use the navigator in the bottom-right for orientation</p>
                        </div>
                    </div>
                </section>
            )}


            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            {/* <SweetAlert
                show={uploadImg}
                title={"File Uploading......"}
                showConfirm={false} // Hides the OK button
            ></SweetAlert> */}


            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={UpdateSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={successMsg}
                onConfirm={e => onUpdateConfirm()}
            >
            </SweetAlert>
            <SweetAlert show={alertMsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Please complete Cases, Module, and Description to activate."}
                onConfirm={e => setAlertMsg(false)}
            >
            </SweetAlert>
            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={alertPopup}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Maximum 10 files allowed"
                focusCancelBtn
                onConfirm={e => setAlertPopup(false)}
            >
            </SweetAlert>
            {/* <SweetAlert show={alertMsg}
                warning
                confirmBtnText="Ok"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Please complete Cases, Module, and Description to activate."
                focusCancelBtn
                onConfirm={e => setAlertMsg(false)}
            >
            </SweetAlert> */}

            <SweetAlert
                show={uploadImg}
                showConfirm={false}
                title=""
            //  onConfirm={() => setAlert(null)}
            >
                <div className="d-flex flex-column align-items-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">File Uploading...</span>
                    </div>
                    <p className="mt-3">File is Uploading...</p>
                </div>
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>

        </>
    );
};

export default AddModule;